import Repository from "./Repository";

const resource = "/users";
export default {
  get() {
    return Repository.get(`${resource}`);
  },

  getUser(usersId) {
    return Repository.get(`${resource}/${usersId}`);
  },

  getConnectedUser() {
    return Repository.get("/me");
  }
};
